import React from "react";
import {
  PageSuspense,
  UserDetail,
  Users,
  Tags,
  Feedback,
  BusinessFeedback,
} from "../lazyComponents";
import NestedUsersPathRedirect from "../../components/MainContent/pages/UserDetail/NestedUsersPathRedirect";
import type { AppRoute } from "../types";

export const usersTagsFeedbackRoutes: AppRoute[] = [
  {
    path: "/user/:id",
    main: () => (
      <PageSuspense>
        <UserDetail />
      </PageSuspense>
    ),
  },
  {
    path: "/users/:userId",
    main: () => <NestedUsersPathRedirect />,
  },
  {
    path: "/users",
    main: () => (
      <PageSuspense>
        <Users />
      </PageSuspense>
    ),
  },
  {
    path: "/tags",
    main: () => (
      <PageSuspense>
        <Tags />
      </PageSuspense>
    ),
  },
  {
    path: "/feedback",
    main: () => (
      <PageSuspense>
        <Feedback />
      </PageSuspense>
    ),
  },
  {
    path: "/Feedback",
    main: () => (
      <PageSuspense>
        <BusinessFeedback />
      </PageSuspense>
    ),
  },
];
